import type { Track } from '@tunasong/schemas'

export const getTrackDuration = (track?: Track) =>
  (track?.clips ?? []).map(clip => clip.start + clip.duration).reduce((prev, cur) => (prev > cur ? prev : cur), 0)

export const getTracksDuration = (tracks?: Track[]) =>
  (tracks ?? []).map(track => getTrackDuration(track)).reduce((prev, cur) => (prev > cur ? prev : cur), 0)
